import { type FC } from 'react';

import { useGetClustersQuery } from '@/packages/query-state/shared/store/search-offers-index/v2/get-clusters-for-map/query';
import { useListingLayoutIsNarrowSelector } from '@/packages/redux-state/store/slices/listingLayout';

import { MapNotifications } from './MapNotifications';

export const MapNotificationsContainer: FC = () => {
  const { isError: isGetClustersError, data: getClustersData, isFetching, isSuccess } = useGetClustersQuery();
  const isNarrowListing = useListingLayoutIsNarrowSelector();

  if (!isNarrowListing || isFetching) {
    return null;
  }

  if (isGetClustersError) {
    return <MapNotifications notificationText="Ошибка загрузки" />;
  }

  if (!getClustersData?.clusters.length && isSuccess) {
    return <MapNotifications notificationText="В данной области ничего не найдено" />;
  }

  return null;
};
